import request from '../axiosInterceptor'

const AiRamsAssessmentModule = {
  // Step 1 of create flow — request presigned S3 PUT URLs for each file.
  // body: { files: [{ file_name, file_type }], module: 'ai-rams-assessment' }
  postRamsGenerateUploadUrls(data: { files: { file_name: string; file_type: string }[]; module: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/ai-rams-assessment/generate-upload-urls`,
      method: 'post',
      data: data,
    })
  },

  // Step 3 of create flow — kick off the async AI evaluation once all files are uploaded to S3.
  // body: { event_id, document_urls: [{ s3_uri, file_name, file_type }], recipients: string[] }
  // event_id is returned at the root of the generate-upload-urls response and echoed back here.
  postRamsCreate(data: { event_id: string; document_urls: { s3_uri: string; file_name: string; file_type: string }[]; recipients: string[] }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/ai-rams-assessment/create`,
      method: 'post',
      data: data,
    })
  },

  // List page — all RAMS assessment reports for the current subsidiary/user scope.
  getRamsList() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/ai-rams-assessment/list`,
      method: 'get',
    })
  },

  getRamsUsersList() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/ai-rams-assessment/users-list`,
      method: 'get',
    })
  },

  // Returns { data: { url } } — a 1-hour presigned GET URL (NOT a blob). Trigger anchor download.
  getRamsDownload(reportId: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/ai-rams-assessment/download?report_id=${reportId}`,
      method: 'get',
    })
  },
}

export default AiRamsAssessmentModule
